export enum UserType {
  SUPPORTER = 'SupporterDetailDTO',
  PATIENT = 'PatientDetailDTO',
  EMPLOYEE = 'EmployeeDetailDTO',
  PSYCHOLOGIST = 'PsychologistDetailDTO',
  ENTERPRISE = 'EnterpriseDTO',
  ADMIN_ENTERPRISE = 'AdminEnterpriseDTO',
}
